import { Alert, Autocomplete, Box, Button, Card, Input, Tab, TabList, TabPanel, Tabs, Typography } from '@mui/joy';
import Checkbox from '@mui/material/Checkbox';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import { post, Token } from '../../../../../Script/Session';
import { FormControlLabel } from '@mui/material';
import { haspermission } from '../../../../../Script/Permission';
function EditTarif({ data, update }) {
    const [value, setValue] = React.useState(0);
    const navigate = useNavigate();
    const [nameinput, setnameinput] = useState();
    const [namesave, setnamesave] = useState(false);
    const [alert, setalert] = useState(false);
    const [selectedgesellschaft, setselectedgesellschaft] = useState(null);
    const [showgesellschaftsave, setshowgesellschaftsave] = useState(false);
    const [editname, seteditname] = useState(false);
    const [edittarif, setedittarif] = useState(false);
    const [editart, seteditart] = useState(false);
    const [showartsave, setshowartsave] = useState(false);
    const [artoptions, setartoptions] = useState(["Tarif", "Konzept", "Empfehlung"]);
    const [selectedart, setselectedart] = useState();
    const [alttarif, setalttarif] = useState(false);
    const [g, setg] = useState();
    const [delperm, setdelperm] = useState(haspermission("20"));
    useEffect(() => {
        if (data) {
            setnameinput(data.name)
        }
    }, []);
    useEffect(() => {
        const fetchVereinData = async () => {
            const body = { token: Token.get(), action: "get" };
            try {
                let response = await post(body, "/gesellschaft");
                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }
                setg(JSON.parse(response).result);
                setselectedgesellschaft(JSON.parse(response).result.find(i => i.id === data.gesellschaftid));
                setselectedart(data?.ftype);
                setalttarif(data.isalttarif);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        setTimeout(fetchVereinData, 15);
    }, []);
    const handleChange = (event, newValue) => {
        if (newValue == 1) {
            navigate("/page-history" + "/tarif_" + data.id);
        }
        setValue(newValue);
    };
    function savename() {
        let body = {};
        body.token = Token.get();
        body.action = "set_field";
        body.targetid = data.id;
        body.field = "setname";
        body.name = nameinput;
        let response = post(body, "/tarife/edit_tarif");
        if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            update();
            setalert(true);
            setnamesave(false);
            seteditname(false);
        }

    }
    function savegesellschaft() {
        let body = {};
        body.token = Token.get();
        body.action = "set_field";
        body.targetid = data.id;
        body.field = "setgesellschaft";
        body.tarigetgessellschaft = selectedgesellschaft.id;
        let response = post(body, "/tarife/edit_tarif");
        if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            update();
            setalert(true);
            setshowgesellschaftsave(false);
            setedittarif(false);
        }


    }
    function saveart() {
        let body = {};
        body.token = Token.get();
        body.action = "set_field";
        body.targetid = data.id;
        body.field = "type";
        if (selectedart == "Tarif") {
            body.isempfehlung = false;
            body.iskonzept = false;
        }
        if (selectedart == "Konzept") {
            body.isempfehlung = false;
            body.iskonzept = true;
        }
        if (selectedart == "Empfehlung") {
            body.isempfehlung = true;
            body.iskonzept = false;
        }
        let response = post(body, "/tarife/edit_tarif");
        if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            setalert(true);
        }
    }
    function savealtarif() {
        let body = {};
        body.token = Token.get();
        body.action = "set_field";
        body.targetid = data.id;
        body.field = "setalttarif";
        body.alttarif = !alttarif;
        let response = post(body, "/tarife/edit_tarif");
        if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            setalert(true);

        }
    }
    function deletetarif() {
        let body = {};
        body.token = Token.get();
        body.action = "delete_tarif";
        body.targetid = data.id;
        body.subkath = data.subkath;
        let response = post(body, "/tarife/edit_tarif");
                if (response == "LOGOUT") {
            navigate("/");
        }
        if (response == "OK") {
            window.history.back();

        }
    }
    return (

        <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: 'divider' }}
        >
            <TabList>
                <Tab>Allgemein</Tab>
                <Tab>Historie</Tab>
                <Tab sx={{ color: "red" }}>Löschen</Tab>
            </TabList>
            <TabPanel value={0}>
                <>
                    {
                        alert && (
                            <Alert
                                sx={{ mb: 5 }}
                                variant="soft"
                                color="success"
                                startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                                endDecorator={
                                    <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                                        Schliesen
                                    </Button>
                                }
                            >
                                Ihre änderungen wurden Erfolgreich gespeichert.
                            </Alert>
                        )
                    }
                    <Card variant='soft'>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
                            <Box sx={{ width: "30%" }}>
                                <Typography level="title-md">Tarifname</Typography>
                                {editname ? (
                                    <Input sx={{}} value={nameinput} onChange={
                                        (e) => {
                                            if (e.target.value != data.name) {
                                                setnamesave(true);
                                            } else {
                                                setnamesave(false);
                                            }
                                            setnameinput(e.target.value);
                                        }
                                    }></Input>
                                ) : (
                                    <Typography>{nameinput}</Typography>
                                )}

                            </Box>
                            {
                                namesave ? (

                                    <Button onClick={() => savename()} sx={{ height: "5%" }}>
                                        Speichern
                                    </Button>
                                ) : (
                                    <Button onClick={() => seteditname(!editname)} sx={{ height: "5%" }}>
                                        Bearbeiten
                                    </Button>
                                )
                            }
                        </Box>
                    </Card>
                    <Card variant='soft' sx={{ mt: 2 }}>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
                            <Box sx={{ width: "30%" }}>
                                <Typography level="title-md">Gesellschaft</Typography>
                                {edittarif ? (
                                    <Autocomplete
                                        options={g}
                                        getOptionLabel={(item) => item.name}
                                        value={selectedgesellschaft}
                                        onChange={(e, newval) => {
                                            setselectedgesellschaft(newval);
                                            if (newval.id != data.gesellschaftid) {
                                                setshowgesellschaftsave(true);
                                            } else {
                                                setshowgesellschaftsave(false);
                                            }

                                        }}
                                    />


                                ) :
                                    (
                                        <Typography>{selectedgesellschaft?.name}</Typography>
                                    )}

                            </Box>
                            {
                                showgesellschaftsave ? (
                                    <Button onClick={() => savegesellschaft()} sx={{ height: "5%" }}>
                                        Speichern
                                    </Button>
                                ) : (
                                    <Button onClick={() => setedittarif(!edittarif)} sx={{ height: "5%" }}>
                                        Bearbeiten
                                    </Button>
                                )
                            }
                        </Box>




                    </Card>
                    <Card sx={{ mt: 2 }} variant='soft'>
                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
                            <Box sx={{ width: "30%" }}>
                                <Typography level="title-md">Tarifart</Typography>
                                {
                                    editart ? (
                                        <Autocomplete
                                            options={artoptions}
                                            value={selectedart}
                                            onChange={(e, newval) => {
                                                setselectedart(newval);
                                                if (newval !== data.ftype) {
                                                    setshowartsave(true);
                                                } else {
                                                    setshowartsave(false);
                                                }
                                            }}
                                        />
                                    ) : (
                                        <Typography>{selectedart}</Typography>
                                    )
                                }
                            </Box>
                            {
                                showartsave ? (
                                    <Button onClick={() => {
                                        seteditart(false);
                                        setshowartsave(false);
                                        saveart();
                                    }} sx={{ height: "5%" }}>
                                        Speichern
                                    </Button>
                                ) : (
                                    <Button onClick={() => seteditart(!editart)} sx={{ height: "5%" }}>
                                        Bearbeiten
                                    </Button>
                                )
                            }
                        </Box>
                    </Card>
                    <Card sx={{ mt: 2 }} variant='soft'>
                        <Box>
                            <Typography level="title-md">Alttarif</Typography>
                            <FormControlLabel control={<Checkbox checked={alttarif} onChange={() => {
                                setalttarif(!alttarif);
                                savealtarif()

                            }} />} label="Alttarif" />
                        </Box>
                    </Card>
                </>
            </TabPanel>
            <TabPanel value={2}>
                {delperm ? (
                    <>
                        <Typography>Achtung Dieser Vorgang ist permanent!</Typography>
                        <Button color='danger' onClick={() => deletetarif()}>
                            Löschen
                        </Button>
                    </>
                ) : (
                    <Typography sx={{ color: "red" }}>Keine Berechtigung. Dieser Vorgang muss von einem Administrator vorgenommen werden!</Typography>
                )}


            </TabPanel>
        </Tabs>

    )
}

export default EditTarif
